import React from 'react';

const LeadHit = ({ hit }) => {
  const getScoreColor = (score) => {
    if (score >= 75) return 'text-green-600 bg-green-50 border-green-200';
    if (score >= 50) return 'text-yellow-600 bg-yellow-50 border-yellow-200';
    if (score >= 25) return 'text-orange-600 bg-orange-50 border-orange-200';
    return 'text-red-600 bg-red-50 border-red-200';
  };

  const getTierColor = (tier) => {
    if (tier === 'Hot Lead') return 'bg-green-100 text-green-800';
    if (tier === 'Warm Lead') return 'bg-yellow-100 text-yellow-800';
    if (tier === 'Cold Lead') return 'bg-orange-100 text-orange-800';
    return 'bg-gray-100 text-gray-800';
  };

  return (
    <div className="bg-white rounded-lg shadow-sm border p-6 hover:shadow-md transition-shadow">
      <div className="flex justify-between items-start mb-4">
        <div>
          <h3 className="text-lg font-semibold text-gray-900">{hit.company_name}</h3>
          <p className="text-gray-600">{hit.contact_name} • {hit.contact_title}</p>
          <p className="text-gray-600">{hit.contact_email}</p>
        </div>

        <div className={`px-3 py-1 rounded-full text-sm font-medium border ${getScoreColor(hit.total_score)}`}>
          {hit.total_score}
        </div>
      </div>

      <div className="grid grid-cols-2 gap-4 mb-4">
        <div>
          <span className="text-sm font-medium text-gray-500">Company Size</span>
          <p className="text-sm text-gray-900">{hit.company_size}</p>
        </div>

        <div>
          <span className="text-sm font-medium text-gray-500">Revenue</span>
          <p className="text-sm text-gray-900">{hit.revenue}</p>
        </div>

        <div>
          <span className="text-sm font-medium text-gray-500">Timeline</span>
          <p className="text-sm text-gray-900">{hit.timeline}</p>
        </div>

        <div>
          <span className="text-sm font-medium text-gray-500">Budget</span>
          <p className="text-sm text-gray-900">{hit.budget}</p>
        </div>
      </div>

      <div className="flex flex-wrap gap-2">
        <span className={`px-2 py-1 rounded-full text-xs font-medium ${getTierColor(hit.lead_tier)}`}>
          {hit.lead_tier}
        </span>

        {hit.demo_request === 'Yes' && (
          <span className="px-2 py-1 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
            Demo Requested
          </span>
        )}

        {hit.budget === 'Budget allocated' && (
          <span className="px-2 py-1 rounded-full text-xs font-medium bg-purple-100 text-purple-800">
            Budget Confirmed
          </span>
        )}

        {hit.authority === 'Decision maker' && (
          <span className="px-2 py-1 rounded-full text-xs font-medium bg-indigo-100 text-indigo-800">
            Decision Maker
          </span>
        )}
      </div>
    </div>
  );
};

export default LeadHit;